import axios from "axios";
import config from "./config";
import qs from "qs";
axios.interceptors.request.use((config) => {
    config.paramsSerializer = (params) => {
        // Qs is already included in the Axios package
        return qs.stringify(params, {
            arrayFormat: "brackets",
            encode: false,
        });
    };
    return config;
});
function getToken() {
    if (config.token != "") {
        return config.token;
    }
    else {
        return window.localStorage.getItem("openkit");
    }
}
let index = {
    async execute(method, url, params, body) {
        let reply = await axios.request({
            method: method,
            url: config.app_url == undefined ? "" : config.app_url + "custom/" + url,
            params,
            data: body,
            headers: {
                Authorization: "Bearer " + getToken(),
            },
        });
        return reply.data;
    },
};
export default index;
